export const editTaskListDropDowns = [
    { dropdownName: "MembershipType", fieldId: "membershipType" },
    { dropdownName: "TransactionType", fieldId: "transactionType" },
];

export const setEditTaskListFormInitials = (apiData, form) => {
    const taskListForm = form;
    taskListForm.initialState.membershipType = apiData.membershipType;
    taskListForm.initialState.transactionType = apiData.transactionType;
    taskListForm.initialState.subscriptionStartDate = apiData.subscriptionStartDate;
    taskListForm.initialState.subscriptionEndDate = apiData.subscriptionEndDate;
    taskListForm.initialState.lastUpdatedDate = apiData.updatedAt;
    taskListForm.initialState.selectedSubscriptionStartDate = apiData.subscriptionStartDate;
    return ({ ...taskListForm })
}

export const setAdmissionCommitteeInitials = (apiData, form) => {
    let formData = { ...form }
    formData.initialState.comments = apiData?.admissionBoardSecretarialSummary;
    formData.initialState.deadline = apiData?.admissionBoardDeadline;
    formData.initialState.additionalNotes = apiData?.admissionBoardAdditionalNotes;
    formData.initialState.admissionCommitteeDate = apiData?.admissionBoardAdmissionCommitteeDate;

    // disble form if admission committee is already submit
    if (apiData?.isAdmissionBoardSubmittedByAdmin)
        formData.formSetting.isViewOnly = true;
    else
        formData.formSetting.isViewOnly = false;

    return ({ ...formData });
}

export const setBoardCommitteeInitials = (apiData, form) => {
    let formData = { ...form }
    formData.initialState.comments = apiData?.boardCommitteeSecretariatSummary;
    formData.initialState.deadline = apiData?.boardCommitteeDeadline;
    formData.initialState.additionalNotes = apiData?.boardCommitteeAdditionalNotes;
    formData.initialState.boardApprovalDate = apiData?.boardCommitteeBoardApprovalDate;

    // disble form if board committee is already submit
    if (apiData?.isBoardCommitteeSubmittedByAdmin)
        formData.formSetting.isViewOnly = true;
    else
        formData.formSetting.isViewOnly = false;

    return ({ ...formData });
}

